// src/components/ClienteViewerDialog.jsx
// Vista de un resultado "cliente" del buscador global — sin navegar.
// Embebe el mismo HistorialCliente que usa la página completa (modo
// `embedded`, mismo patrón que ya usan TrsRastreoUsuariosPage y
// ReporteClienteResumenPage), así el usuario ve todo el detalle
// (equipos, chips, historial, plataformas...) dentro del dialog.
import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HistorialCliente from "../modules/historialCliente/pages/HistorialCliente";

export default function ClienteViewerDialog({ open, onClose, cliente }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "1rem", fontWeight: 800 }}>
        {cliente?.titulo || "Cliente"} ({cliente?.id ?? "—"})
        <IconButton size="small" onClick={onClose} aria-label="Cerrar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {cliente && (
          <HistorialCliente codServicioClienteProp={cliente.id} embedded onBack={onClose} />
        )}
      </DialogContent>
    </Dialog>
  );
}
